import { render, staticRenderFns } from "./Tarifas.vue?vue&type=template&id=e5bb04b2&scoped=true&"
import script from "./Tarifas.vue?vue&type=script&lang=js&"
export * from "./Tarifas.vue?vue&type=script&lang=js&"
import style0 from "./Tarifas.vue?vue&type=style&index=0&id=e5bb04b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bb04b2",
  null
  
)

export default component.exports